<template>
  <aside class="floating-qr" :aria-label="isEn ? 'Floating QR bar' : '二维码悬浮栏'" :style="{ transform: `translateY(${offsetY}px)` }">
    <div class="head">{{ isEn ? 'Scan to Contact' : '扫码咨询' }}</div>
    <div class="qr">
      <div class="qrbox" :aria-label="isEn ? 'WeChat consultation QR code' : '微信咨询二维码'">
        <img :src="$oss('static/img/contact-qr-wechat.jpg')" alt="微信二维码" style="width:74px;height:74px;object-fit:contain;" loading="lazy" />
      </div>
    </div>
    <div class="cap">{{ isEn ? 'WeChat Scan Support' : '微信扫码咨询' }}</div>
  </aside>
</template>

<script>
export default {
  name: 'FloatingQR',
  computed: {
    isEn() {
      return this.$getLocale() === 'en-US'
    }
  },
  data() {
    return { offsetY: 0 }
  },
  mounted() {
    this._onScroll = () => {
      this.offsetY = Math.sin((window.scrollY || 0) / 140) * 6
    }
    window.addEventListener('scroll', this._onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll)
  }
}
</script>
